import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { registerUser } from '../../store/actions/users/users.action';
import CreateUser from '../../components/Users/CreateUser';
import PageLoader from '../../components/Common/PageLoader';

const CreateUserContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const isCreating = useSelector((state) => state.users.isCreating);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [accessMode, setAccessMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      if (!categories || !Array.isArray(categories)) {
        setAccessDenied(true);
        return;
      }

      const userCategory = categories.find(category => category.link === 'users');

      if (userCategory && userCategory.mode) {
        setAccessMode(userCategory.mode);
        setAccessDenied(false);
      } else {
        setAccessDenied(true);
      }
    } catch (err) {
      console.error('Error setting access:', err);
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle user registration
  const handleRegisterUser = useCallback((userData) => {
    return dispatch(registerUser(userData));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    setAccess();
  }, [setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Access denied state
  if (accessDenied) {
    return (
      <div className="access-denied">
        This category is not accessible to the logged in user.
      </div>
    );
  }

  // Permission check for edit mode
  if (accessMode !== 'edit') {
    return (
      <div className="access-restricted">
        You don't have permission to create users.
      </div>
    );
  }

  return (
    <div id="create-user">
      <CreateUser
        registerUser={handleRegisterUser}
        isCreating={isCreating}
        accessMode={accessMode}
      />
    </div>
  );
};

export default CreateUserContainer;
